var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoSmartFlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 18.43",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.43a3 3 0 013 3 3 3 0 01-3 3 2.99 2.99 0 01-2.83-2H11v-2h1.17c.41-1.17 1.52-2 2.83-2m0 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1m0-9A1.43 1.43 0 0016.43 4a1.43 1.43 0 10-2.86 0A1.43 1.43 0 0015 5.43M15 0a4 4 0 014 4c0 2.99-4 7.43-4 7.43S11 6.99 11 4a4 4 0 014-4M5.83 14.43H7v2H5.83a2.99 2.99 0 01-2.83 2 3 3 0 01-3-3c0-1.31.83-2.42 2-2.83v-1.17h2v1.17c.85.3 1.53.98 1.83 1.83m-2.83 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1m0-14a3 3 0 013 3c0 1.31-.83 2.42-2 2.83v1.17H2V6.26a2.99 2.99 0 01-2-2.83 3 3 0 013-3m0 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1m5 14v-2h2v2H8m-4-6H2v-2h2z",
    fill: "currentColor"
  })));
}

export default SvgEykoSmartFlow;